<template>
  <div :class="'hexagon hexagon-custom ' + hexagonClass" :style="cssVars">
    <div class="hexagon-inner">
      <span class="hexagon-name">{{ title }}</span>
      <p class="hexagon-metric-label mb-0">
        <span :title="vnsIconsUpdated ? vnsIconsUpdated.type.title : ''">
          <i :class="'fa fa-' + vnsIconsUpdated.type.icon" aria-hidden="true" />
        </span>
        {{ textPrimary }}
      </p> 
      <p class="hexagon-metric-label mb-0">
        {{ textSubTitle }}
      </p>
      <p class="hexagon-metric-sub-label mb-0">
        {{ textSecondary }}
      </p>
      <div class="hexagon-icons">
        <span v-if="vnsIconsUpdated.center.show" :class="vnsIconsUpdated.center.span" @click="$emit('click-center')" :title="vnsIconsUpdated ? vnsIconsUpdated.center.title : ''" style="cursor: pointer;">
          <i :class="'fa fa-' + vnsIconsUpdated.center.icon"/>
        </span>
        <span v-if="vnsIconsUpdated.left.show" :class="vnsIconsUpdated.left.span" @click="$emit('click-left')">
            <i :class="'fa fa-' + vnsIconsUpdated.left.icon"/>
        </span>
        <span v-if="vnsIconsUpdated.right.show" :class="vnsIconsUpdated.right.span" @click="$emit('click-right')">
            <i :class="'fa fa-' + vnsIconsUpdated.right.icon"/>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vnsHexagon",
  props: {
    title: {
      type: String,
      default: ''
    },
    textPrimary: {
      type: String,
      default: ''
    },
    textSecondary: {
      type: String,
      default: ''
    },
    textSubTitle: {
      type: String,
      default: ''
    },
    hexagonClass: {
      type: String,
      default: ''
    },
    hexagonCustom: {
      type: Array,
      default: () => []
    },
    vnsIcons: {
      type: Object,
      default: {}
    }
  },
  computed: {
    cssVars() {
      return {
        '--custom-background-color': this.customBackgroundColor,
        '--custom-color': this.customColor
      }
    },
    vnsIconsUpdated() {
      if (Object.entries(this.vnsIcons).length > 0) {
        const leftClass = [...this.icons.left.span, ...this.vnsIcons.left.span]
        const centerClass = [...this.icons.center.span, ...this.vnsIcons.center.span]
        const rightClass = [...this.icons.right.span, ...this.vnsIcons.right.span]
        this.icons = this.vnsIcons
        this.icons.left.span = leftClass
        this.icons.center.span = centerClass
        this.icons.right.span = rightClass
      }
      
      return this.icons
    }
  },
  data() {
    return {
      customBackgroundColor: '#f8f9fc',
      customColor: '#000',
      icons: {
        left: {
          show: false,
          span: ['hexagon-icon-left'],
          icon: ''
        },
        center: {
          show: false,
          span: ['hexagon-featured-score'],
          icon: '',
          title: ''
        },
        right: {
          show: false,
          span: ['hexagon-icon-right'],
          icon: ''
        }
      }
    }
  },
  mounted() {
    if (Object.entries(this.vnsIcons).length > 0) {
      const leftClass = [...this.icons.left.span, ...this.vnsIcons.left.span]
      const centerClass = [...this.icons.center.span, ...this.vnsIcons.center.span]
      const rightClass = [...this.icons.right.span, ...this.vnsIcons.right.span]
      this.icons = this.vnsIcons
      this.icons.left.span = leftClass
      this.icons.center.span = centerClass
      this.icons.right.span = rightClass
    }
    if (this.hexagonCustom.bgColor && this.hexagonCustom.bgColor !== '') this.customBackgroundColor = this.hexagonCustom.bgColor
    if (this.hexagonCustom.fontColor && this.hexagonCustom.fontColor !== '') this.customColor = this.hexagonCustom.fontColor
  }
}
</script>

<style lang="scss" scoped>
.hexagon-custom {
  background-color: var(--custom-background-color);
  color: var(--custom-color);

  &:before {
    border-bottom: 40.41px solid var(--custom-background-color);
  }

  &:after {
    border-top: 40.41px solid var(--custom-background-color);
  }
}

/* Hexagon */
.hexagon {
  position: relative;
  width: 140px;
  height: 80.83px;
  margin: 44px 2px 0;
  display: flex;
  justify-content: center;
  align-items: center;

  &:before, &:after {
    content: "";
    position: absolute;
    width: 0;
    border-left: 70px solid transparent;
    border-right: 70px solid transparent;
  }

  &:before {
    bottom: 100%;
  }

  &:after {
    top: 100%;
    width: 0;
  }
}

/* Inner Hexagon */
.hexagon-inner {
  width: 136px;
  height: 78.52px;
  margin: 39.26px 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;

  &:before, &:after {
    content: "";
    position: absolute;
    width: 0;
    border-left: 68px solid transparent;
    border-right: 68px solid transparent;
    z-index: 1;
  }

  &:before {
    bottom: 100%;
    border-bottom: 39.26px solid transparent;
  }

  &:after {
    top: 100%;
    width: 0;
    border-top: 39.26px solid transparent;
  }
}

/* Name */
.hexagon-name {
  width: 115px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  font-weight: 800;
  font-size: 14px;
  margin-top: -14px;
  z-index: 1;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}

/* Metric */
.hexagon-metric-label {
  width: 134px;
  text-align: center;
  font-weight: 700;
  font-size: 12px;
  z-index: 1;
}

.hexagon-metric-sub-label {
  width: 134px;
  text-align: center;
  font-weight: 300;
  font-size: 12px;
  z-index: 1;
}

.hexagon-icons {
  display: flex;
  justify-content: space-around
}

/* Score */
.hexagon-featured-score {
  position: absolute;
  z-index: 2;
  bottom: -24px;
  width: 32px;
  height: 32px;
  border-radius: 36px;
  border: 1px solid;
  text-align: center;
  padding-top: 9px;
  font-weight: 700;
  font-size: 12px;
}

/* Right / Left Icons */
.hexagon-icon-left, .hexagon-icon-right {
  position: absolute;
  z-index: 2;
  top: 58px;
  width: 24px;
  height: 24px;
  border-radius: 24px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  cursor: pointer;
}

.hexagon-icon-left {
  left: 3px;
}

.hexagon-icon-right {
  right: 3px;
}
</style>
